/**
 * Possible statuses for a task state
 */
const STATUS = {
	pending: 'pending',
	loading: 'loading',
	resolved: 'resolved',
	rejected: 'rejected',
};

/**
 * Helper object of state creator for easier state change
 */
export const predefinedStates = {
	[STATUS.loading]: () => ({
		status: STATUS.loading,
		error: null,
		result: null,
	}),

	[STATUS.pending]: () => ({
		status: STATUS.pending,
		error: null,
		result: null,
	}),

	[STATUS.resolved]: result => ({
		status: STATUS.resolved,
		error: null,
		result,
	}),

	[STATUS.rejected]: error => ({
		status: STATUS.rejected,
		result: null,
		error,
	}),
};

/**
 * Create a new state object based on a status
 *
 * @param {Object<STATES>} status New state status
 * @param {*} data Data to be passed to the creator
 * @returns {Object} Task state
 */
export function stateCreator(status, data = null) {
	return predefinedStates[status](data);
}

export default STATUS;



// WEBPACK FOOTER //
// ./src/state/helpers/task/states.js